import { Injectable }                                                           from '@angular/core';
import { Router }                                                               from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse }   from '@angular/common/http';
import { Errors }                                                               from '../models/errors.model';
import {LocalStorageService, LOGIN_ERROR, REDIRECT_POST_LOGIN, SSO_PROVIDER, U_SSO_URL} from '../services/local-storage.service';

interface ApiErrorBody {
    error?: boolean;
    code?: string | number;
    message?: string;
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private router: Router, private localStorageService: LocalStorageService) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request)
            .pipe(
                map((response: HttpEvent<ApiErrorBody>) => {
                    if (response instanceof HttpResponse) {
                        if (response.body.error) {

                            // check for auth errors, redirect
                            switch (response.body.code) {

                                // use codes from a static model
                                case Errors.NOT_AUTHENTICATED:
                                    this.localStorageService.setItem(REDIRECT_POST_LOGIN, window.location.pathname);
                                    this.localStorageService.setItem(LOGIN_ERROR, response.body.message);

                                    if (window.location.pathname !== '/password-reset' &&
                                        window.location.pathname !== '/not-supported') {
                                        this.router.navigate(['/login']);
                                    }

                                    break;

                                case Errors.SSO_USER_REDIRECT: {
                                    const ssoEndpoints: Record<string, string> = {
                                        'default': '/v2/account/login/sso',
                                        'diageo': '/v2/account/login/diageo/sso',
                                        'diageoHhg': '/v2/account/login/hhg/sso',
                                        'diageoPartners': '/v2/account/login/partners/sso',
                                    };
                                    const provider = this.localStorageService.getItem(SSO_PROVIDER);
                                    const url = ssoEndpoints[provider] || this.localStorageService.getItem(U_SSO_URL);

                                    if (!url) {
                                        this.router.navigate(['/errors/sso-gateway']);
                                        return;
                                    }

                                    window.location.href = url;
                                    break;
                                }

                                default:
                                    //! we want the caller to handle non-specified errors...
                            }
                        }
                    }

                    return response;
                })
            );
    }
}
